import { Modal, Box, Typography, Divider, IconButton, Grid } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function TrackScoreModal({ open, handleClose, trackData }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 500 },
          // width: '80%',
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 10,
          p: { xs: 1.5, sm: 4 },
          maxHeight: '90vh',
          overflowY: 'auto',
          overflowWrap: 'break-word',

        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: 'grey.600',
            bgcolor: 'grey.100',
            '&:hover': {
              bgcolor: 'grey.200',
            },
            width: 36,
            height: 36,
          }}
        >
          <CloseRoundedIcon />
        </IconButton>

        <Typography variant="h6" fontWeight="bold" textAlign="center" mb={2}>
          Track Score Details
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={1.5}>
          <Grid item xs={6}>
            <Typography fontWeight="bold">Topic Name</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography color="text.secondary">{trackData?.topic_Name || 'N/A'}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography fontWeight="bold">Track Score</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography color="text.secondary">{trackData?.track_score ?? '--'}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography fontWeight="bold">Technical Ability Score</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography color="text.secondary">{trackData?.track_techability_score ?? '--'}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography fontWeight="bold">Learnability Score</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography color="text.secondary">{trackData?.track_learnability_score ?? '--'}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography fontWeight="bold">Communicability Score</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography color="text.secondary">{trackData?.track_communicability_score ?? '--'}</Typography>
          </Grid>
        </Grid>


        <Divider sx={{ my: 2}} />

        <Typography fontWeight="bold" gutterBottom>
          Review Comment
        </Typography>

        <Box
          sx={{
            bgcolor: 'grey.100',
            p: 2,
            borderRadius: 2,
            fontSize: '0.95rem',
            color: 'text.secondary',
            whiteSpace: 'pre-line',
          }}
        >
          {trackData?.track_remarks || 'No comment provided.'}
        </Box>

        <Typography
          variant="caption"
          display="block"
          sx={{ mt: 3, textAlign: 'right', color: 'text.disabled' }}
        >
          <strong>Review Date : </strong>{' '}
          {trackData?.review_date
            ? new Date(trackData.review_date).toLocaleDateString('en-GB')
            : '--'}
        </Typography>
      </Box>
    </Modal>
  );
}
